var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4D7CBF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 196,
    cy: 195,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,270c-19.6,0-36.2,12.5-42.4,30h84.9C232.2,282.5,215.6,270,196,270z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406,0H256c-41.4,0-75,33.6-75,75v15H61v422h270V90H211V75c0-24.8,20.2-45,45-45h5.1 c31.4,0,60.9,12.2,83,34.4C360.5,80.7,383,90,406,90c24.8,0,45-20.2,45-45S430.8,0,406,0z M121,360h30v30h-30V360z M271,450H121 v-30h150V450z M181,390v-30h30v30H181z M271,390h-30v-30h30V390z M241,195c0,24.8-20.2,45-45,45c41.4,0,75,33.6,75,75v15H121v-15 c0-41.4,33.6-75,75-75c-24.8,0-45-20.2-45-45s20.2-45,45-45S241,170.2,241,195z M406,60c-15.1,0-29.9-6.1-40.6-16.8 c-4.8-4.8-9.8-9.2-15.1-13.2H406c8.3,0,15,6.7,15,15S414.3,60,406,60z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCardIcon);
export default __webpack_public_path__ + "static/media/id-card-icon.ee8710e10b9d7f5fa9091af31411d34c.svg";
export { ForwardRef as ReactComponent };